import { forwardRef } from 'react'

import classNames from 'classnames'

import { ClickableProps } from '@web/ui/components/Clickable/context'

import styles from './Clickable.module.scss'

const UIClickable = forwardRef<HTMLButtonElement, ClickableProps>(function UIClickable(
  { children, role, className, disabled = false, onClick, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      role={role}
      className={classNames(styles.clickable, className)}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  )
})

export default UIClickable
